import React from 'react'
import './Footer.css';
import Analytics from './Analytics';

function Footer() {
    const footerYear = new Date().getFullYear()

    return (
        <>
            {/* <div className="links-container">
                <div className="links-wrap">
                    {/* <p className='links-head'><span>Quick Links</span></p> */}
                    {/* <div className="link-row">
                        <div className="link-box box1">
                            <img src={process.env.PUBLIC_URL + "/images/Home/Acc_GT_Dimensional_RGB.png"} alt="AccentureIcon" className='accenture-icon' />
                            <p className='follow-site'>Follow our site</p>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://idcquality.accenture.com/#/default" target="_blank">ATCI Quality Portal<img src={process.env.PUBLIC_URL + "/images/Home/popup-latest.png"} alt="PopupIcon" className='links-icon' /></a>
                        </div>
                    </div>  */}
                    {/* <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://atci.lkm.accenture.com/newhome" target="_blank">LKM  <img src= {process.env.PUBLIC_URL + "/images/Home/popup-latest.png"} alt="PopupIcon" className='links-icon' /></a>
                        </div>
                    </div> */}
                    {/* <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://connectedlearning.accenture.com/learningactivities" target="_blank">Learning Boards <img src="images/Home/popup-latest.png" alt="PopupIcon" className='links-icon' /></a>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="link-box last-two-links">
                            <a href="https://atci.lkm.accenture.com/learning-calendar" target="_blank">LKM Calendar <img src="images/Home/popup-latest.png" alt="PopupIcon" className='links-icon' /></a>
                        </div>
                    </div> */}
                {/* </div>
            </div> */}
            <div className="footer_container">
                <p>© {footerYear} Accenture. All Rights Reserved. Accenture Confidential. For internal use only. Powered by Learning Experiences - L&TT, ATCI.
                    <Analytics />
                </p>
            </div>
        </>
    )
}

export default Footer
